// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 629 ? "npm.react-app-polyfill" : chunkId) + "." + {"414":"9d6c0482","629":"6009219a"}[chunkId] + ".chunk.js";
};